var METRIC_AUTHORING_MODE = /* @__PURE__ */ ((METRIC_AUTHORING_MODE2) => {
  METRIC_AUTHORING_MODE2["custom"] = "custom";
  METRIC_AUTHORING_MODE2["template"] = "template";
  METRIC_AUTHORING_MODE2["code"] = "code";
  return METRIC_AUTHORING_MODE2;
})(METRIC_AUTHORING_MODE || {});
const FIELD_NAMES = {
  mode: "mode",
  name: "name",
  internalName: "internalName",
  description: "description",
  level: "level",
  categories: "categories",
  desiredDirection: "desiredDirection",
  computationFilePath: "computationFilePath",
  metricTemplate: "metricTemplate"
};
const METRIC_DIRECTIONS = {
  Increase: "Increase",
  Decrease: "Decrease",
  Neutral: "Neutral"
};
const colorSchemeToMetricDirection = {
  Inverse: "Decrease",
  Default: "Increase",
  Neutral: "Neutral"
};
const metricDefinitionToColorScheme = {
  Decrease: "Inverse",
  Increase: "Default",
  Neutral: "Neutral"
};
const DEFAULT_METADATA = {
  name: "",
  internalName: "",
  level: "",
  mode: "custom",
  description: "",
  categories: [],
  desiredDirection: "",
  computationFilePath: "UserDefinedFiles\\MDLComputations.xml",
  metricTemplate: "",
  instanceIdToBeEdited: ""
};
const CREATE_MODAL_FIED_VALIDATION = {
  name: { required: "Required" },
  internalName: {
    required: "Required",
    pattern: {
      value: /^\w+$/,
      message: "Internal name can only contain alphabetical characters[a-zA-Z], digits[0-9] and underscore[_]"
    },
    duplicate: "Metric internal name already exists."
  },
  description: { required: "Required" },
  level: { required: "Required" },
  desiredDirection: {
    required: "Required"
  },
  metricTemplate: { required: "Required" }
};
const BASE_LEVEL_NAME = "Base";
const METRIC_WIZARD_CATEGORY = "MetricWizard";
export {
  BASE_LEVEL_NAME,
  CREATE_MODAL_FIED_VALIDATION,
  DEFAULT_METADATA,
  FIELD_NAMES,
  METRIC_AUTHORING_MODE,
  METRIC_DIRECTIONS,
  METRIC_WIZARD_CATEGORY,
  colorSchemeToMetricDirection,
  metricDefinitionToColorScheme
};
//# sourceMappingURL=CreateModal.constants.js.map
